const DESKTOP_WIDTH = 400
let activePopover = null
let closeHandlerController = null

export function showPopover(nodeData, svgElement, event) {
  hidePopover()

  const isMobile = window.innerWidth < 768
  const container = getOrCreateContainer(svgElement)

  if (isMobile) {
    showMobilePopover(container, nodeData)
  } else {
    showDesktopPopover(container, nodeData, event)
  }
}

export function hidePopover() {
  if (activePopover) {
    activePopover.remove()
    activePopover = null
  }
}

export function showTooltip(nodeData, event) {
  if (window.innerWidth < 768) return null

  hideTooltip()
  const tip = document.createElement("div")
  tip.id = "tree-tooltip"
  tip.className = "tree-tooltip"
  tip.textContent = nodeData.displayName
  tip.style.left = `${event.pageX + 10}px`
  tip.style.top = `${event.pageY - 30}px`
  document.body.appendChild(tip)
  return tip
}

export function hideTooltip() {
  const existing = document.getElementById("tree-tooltip")
  if (existing) existing.remove()
}

function getOrCreateContainer(svgElement) {
  const parent = svgElement.closest("[data-controller~='tree-graph']")
  if (!parent) return null
  let container = parent.querySelector(".tree-popover-container")
  if (!container) {
    container = document.createElement("div")
    container.className = "tree-popover-container"
    parent.appendChild(container)
  }
  return container
}

function showMobilePopover(container, nodeData) {
  const frame = createTurboFrame(nodeData.popoverUrl)
  frame.className = "tree-popover tree-popover--mobile"
  container.appendChild(frame)
  activePopover = frame
}

function showDesktopPopover(container, nodeData, event) {
  const frame = createTurboFrame(nodeData.popoverUrl)
  frame.className = "tree-popover tree-popover--desktop"

  const rect = container.getBoundingClientRect()
  const clickX = event.clientX - rect.left
  const clickY = event.clientY - rect.top

  // Position to the right of the node, with enough offset to avoid overlap
  let left = clickX + 80
  let top = clickY - 60

  // If too far right, flip to the left side
  if (left + DESKTOP_WIDTH > rect.width) {
    left = clickX - DESKTOP_WIDTH - 20
  }
  if (left < 10) left = 10
  if (top < 10) top = 10
  if (top + 300 > rect.height) top = rect.height - 310

  frame.style.left = `${left}px`
  frame.style.top = `${top}px`
  frame.style.maxWidth = `${DESKTOP_WIDTH}px`
  container.appendChild(frame)
  activePopover = frame
}

function createTurboFrame(url) {
  const frame = document.createElement("turbo-frame")
  frame.id = "person_popover"
  frame.src = url
  frame.loading = "eager"
  frame.setAttribute("role", "dialog")
  return frame
}

export function cleanupCloseHandlers() {
  if (closeHandlerController) {
    closeHandlerController.abort()
    closeHandlerController = null
  }
}

export function setupCloseHandlers(svgElement) {
  cleanupCloseHandlers()

  closeHandlerController = new AbortController()
  const { signal } = closeHandlerController

  document.addEventListener("click", (e) => {
    if (activePopover && !activePopover.contains(e.target) &&
        !e.target.closest(".tree-node")) {
      hidePopover()
    }
  }, { signal })

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") hidePopover()
  }, { signal })
}
